import { COMPONENT_FACTORY_CONFIG_INPUT_COMPONENTS } from '@core/components/component-factory/component-factory-config-input.registry';
import type { ConfigComponentContract } from '@shared/utils/content-builder/config-component-contract';
import { computedResolvedConfig } from '@shared/utils/content-builder/block-config-computed-resolver';
import type { CartFunnelFormBlockConfig } from '@front-platform/content-builder';
import { cartFunnelFormBlockResolveConfig } from '@front-platform/content-builder';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Component, input } from '@angular/core';
import { CartFunnelStoreSelector } from '@common/selectors/cart-funnel.selector';
export interface CartFunnelFormBlockRuntimeConfig {
  'block_id'?: string;
  'items'?: unknown[];
}

export type CartFunnelFormBlockConfigInput = Partial<
  Omit<CartFunnelFormBlockConfig, keyof CartFunnelFormBlockRuntimeConfig> &
    CartFunnelFormBlockRuntimeConfig
>;
export type CartFunnelFormBlockResolvedConfig = Omit<
  CartFunnelFormBlockConfig,
  keyof CartFunnelFormBlockRuntimeConfig
> &
  Partial<CartFunnelFormBlockRuntimeConfig>;
export interface CartFunnelFormBlockContract extends ConfigComponentContract<
  CartFunnelFormBlockConfigInput,
  CartFunnelFormBlockResolvedConfig
> {}

@Component({
  selector: 'app-cart-funnel-form-block',
  templateUrl: './cart-funnel-form-block.component.html',
  standalone: false,
})
export class CartFunnelFormBlockComponent implements CartFunnelFormBlockContract {
  readonly config = input<CartFunnelFormBlockConfigInput>({});
  readonly resolvedConfig = computedResolvedConfig<
    CartFunnelFormBlockConfig,
    CartFunnelFormBlockRuntimeConfig
  >(cartFunnelFormBlockResolveConfig, () => ({ config: this.config() }));
  get title(): string {
    return this.resolvedConfig()['title'] as unknown as string;
  }
  get blockId(): string {
    return this.resolvedConfig()['block_id'] as unknown as string;
  }
  get items(): unknown[] {
    return this.resolvedConfig()['items'] as unknown as unknown[];
  }

  isActive$: Observable<boolean> = this.cartFunnelSelector.selectActiveStepId.pipe(
    map(id => id === this.blockId),
  );

  constructor(private cartFunnelSelector: CartFunnelStoreSelector) {}
}
COMPONENT_FACTORY_CONFIG_INPUT_COMPONENTS.set(CartFunnelFormBlockComponent, { 'keyAliases': {} });
